import './assets/scss/styles.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import Cookies from 'js-cookie';
import type { RouteLocationNormalized } from 'vue-router';

import App from './App.vue';
import router from './router';
import setOptOutCookies from '@/helpers/SetCookies';
import type { Config } from './types/config';
import { components as HomeFnolComponents } from 'propertyit-fnol-external-component';
import { components as FloodFnolComponents } from 'propertyit-flood-fnol-external-component';

// @ts-expect-error This global config variable makes things grumpy
if (typeof config == 'undefined') {
    console.error('Cannot find config object.');
    throw new Error('Cannot find config object.');
}
// @ts-expect-error This global config variable makes things grumpy
const typedConfig = config as Config;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    const OptOutPrefCookie = Cookies.get('PgrOptOutPref');

    if (!OptOutPrefCookie) {
        const PgrOptOutPrefKey = router.currentRoute.value.query?.PgrOptOutPref === '0' ? '0' : '1';
        setOptOutCookies(PgrOptOutPrefKey);
    }
});

const app = createApp(App);
// @ts-expect-error This global config variable makes things grumpy
app.provide('config', config);

if (window.self !== window.top && window.top) {
    window.top.location.href = window.self.location.href;
}

app.use(createPinia());
app.use(router);
app.component('FnolCorporatePageContent', HomeFnolComponents.FnolCorporatePageContent);
app.component('HomeFnolSearch', HomeFnolComponents.FnolSearch);
app.component('FloodFnolSearch', FloodFnolComponents.FnolSearch);
app.mount('#app');

import 'bootstrap';
